<template>
  <el-table-column
    :min-width="minWidth"
    :prop="prop"
    :label="getLabel"
    :align="'center'"
  >
    <template slot-scope="scope">
      <el-badge
        class="custom-el-badge__content item"
        v-if="getDataLength(scope.row) > 0"
        :hidden="getDataLength(scope.row) == 1 ? true : false"
        :value="200"
        :max="getDataLength(scope.row) - 1"
      >
        <el-button plain type="info" size="small">
          {{ getTextFromBadge(scope.row) }}</el-button
        >
      </el-badge>
    </template>
  </el-table-column>
</template>
<script>
import i18n from 'src/i18n';
export default {
  computed: {
    getLabel() {
      return this.label ? this.label : i18n.t('common_words.associated_users2');
    },
  },
  name: 'table-column-badges',
  props: {
    prop: {
      type: String,
      default: 'props.users',
    },
    label: {
      type: String,
      default: null,
    },
    fromData: {
      type: String,
      default: 'users',
    },
    textBadge: {
      type: String,
      default: 'fullname',
    },
    minWidth: {
      type: Number,
      default: 0,
    },
    isObject: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    getDataLength(row) {
      return row[this.fromData] ? row[this.fromData].length : 0;
    },

    getTextFromBadge(row) {
      return this.isObject
        ? row[this.fromData][0][this.textBadge]
        : row[this.fromData][0];
    },
  },
};
</script>
